export const TinyMCEContent = (props) => {
    const {content} = props;

    return (
        <div className={"tinyMceParagraph"} dangerouslySetInnerHTML={{__html: content}}/>
    )
};